/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  roles.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/3/11 14:30
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import {axiosAPIUrl, Parameter, assignParams} from "./index";

export interface RolesDto {
    roleId?: string // 员工角色id
    roleName?: string // 员工角色名称
    isAdministrator?: string // 是否是管理员
}

export class sysMenuDTO {
    /** 接口请求方法 */
    apiMethod?: "POST" | "GET" | "PUT" | "DELETE" | "PATCH";

    /** 接口读写模式 r读、w写 */
    apiMode?: string;

    /** children */
    children?: Array<sysMenuDTO>;

    /** 所属系统 */
    clientId?: string | { key: string; label: string };

    /** 所属系统名 */
    clientName?: string;

    /** 是否默认授权 */
    defaultGrant?: boolean;

    /** 是否启用 1：是，0否 */
    enabled?: boolean;

    /** 表单 */
    // grids?: Array<SysGridDTO>;

    /** id */
    id!: string;

    /** 所有父级菜单 */
    levelIds?: string;

    /** 菜单图标 */
    menuIcon?: string;

    /** 编号 */
    menuId!: string;

    /** 菜单名称 */
    menuName!: string;

    /** 菜单类型 */
    menuType!: string;

    /** 菜单地址 */
    menuUrl?: string;

    /** 父级菜单 */
    parentId?: string;

    /** 排序号 */
    priority!: number;

    /** 菜单标识 */
    actionName!: string;

    /** 是否半选 */
    halfChecked!: boolean;

    /** 路由路径 */
    routePath?: string;

    /** 给tree的第一层级添加一个插槽 (tree组件的需要) */
    slots?: any;
}

/**
 * 获取公司角色
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function GetRoleByCompany (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjusercenter/Departmentstaff/server/getRoleByCompany',
        method: 'get',
        params: { ...parameter, ...assignParams() }
    })
}

/**
 * 获取角色权限
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function GtRoleMenu (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjusercenter/MR/getRoleMenu',
        method: 'get',
        params: parameter
    })
}

/**
 * 获取权限树
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function getMenuListByCykj (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: '/cykjusercenter/MR/getMenuListByCykj',
        method: 'post',
        data: parameter
    })
}


/**
 * 授权权限菜单
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function DistributeMenu (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: `/cykjusercenter/MR/distributeMenu`,
        method: 'post',
        data: parameter
    })
}

/**
 *  修改角色名称
 * @export
 * @param {Parameter} [parameter={}]
 * @returns
 */
export function updateRoleName (parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<any>>({
        url: '/cykjusercenter/MR/updateRoleName',
        method: 'post',
        data: parameter
    })
}
